export class MonthSmeltingProductInfo {
    constructor({
          id= null,         
          month= ``,
          locName= ``,          
          productName= ``,
          electricCost= ``,
          basicElectricCost= ``,
          productMass= ``,
          basicProductMass= ``,
          CrPercent= ``,
          operationRate= ``,
          recycleRate= ``,
          mineralConsumeRate= ``,
          ballConsumeRate= ``,
          earthConsumeRate= ``,
          coalConsumeRate= ``,
          stoneConsumeRate= ``,
          materialPercent= ``,
          
      } = {}) {
      this.id = id;
      this.month = month;
      this.locName = locName;  
      this.productName = productName;    
      this.electricCost = electricCost;
      this.basicElectricCost = basicElectricCost;
      this.productMass = productMass;
      this.basicProductMass = basicProductMass;
      this.CrPercent = CrPercent;
      this.operationRate = operationRate;
      this.recycleRate = recycleRate;
      this.mineralConsumeRate = mineralConsumeRate;
      this.ballConsumeRate = ballConsumeRate;
      this.earthConsumeRate = earthConsumeRate;
      this.coalConsumeRate = coalConsumeRate;
      this.stoneConsumeRate = stoneConsumeRate;
      this.materialPercent = materialPercent;
    }
  }
  export function gridFields() {
    return Object.freeze([        
        {
          key: 'locName',
          label: 'lbl.basic.locName',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'month',
          label: 'lbl.basic.month',
          sortable: true,
          form: {
            type: 'month'
          }
        },                        
        {
          key: 'productName',
          label: 'lbl.prd.execution.productionName',
          sortable: false,
          form: {
            type: 'input'
          }
        },               
        {
          key: 'electricCost',
          label: 'lbl.prd.execution.electricCost',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'basicElectricCost',
          label: 'lbl.prd.execution.basicElectricCost',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'productMass',
          label: 'lbl.prd.execution.productMass',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'basicProductMass',
          label: 'lbl.prd.execution.basicProductMass',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'CrPercent',
          label: 'Cr%',
          sortable: false,
          form: {
            type: 'input'
          }
        }
        // {
        //   key: 'operationRate',
        //   label: 'lbl.prd.execution.operationRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'recycleRate',
        //   label: 'lbl.prd.execution.recycleRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'mineralConsumeRate',
        //   label: 'lbl.prd.execution.mineralConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'ballConsumeRate',
        //   label: 'lbl.prd.execution.ballConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'earthConsumeRate',
        //   label: 'lbl.prd.execution.earthConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'coalConsumeRate',
        //   label: 'lbl.prd.execution.coalConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'stoneConsumeRate',
        //   label: 'lbl.prd.execution.stoneConsumeRate',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // },
        // {
        //   key: 'materialPercent',
        //   label: 'lbl.prd.execution.materialPercent',
        //   sortable: false,
        //   form: {
        //     type: 'input'
        //   }
        // }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new MonthSmeltingProductInfo()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.plantFilter',
    'filter.startMonthFilter',
    'filter.endMonthFilter',  
    
  ];
  export const filter = {
    'plantFilter': "",
    'startMonthFilter': "",
    'endMonthFilter': "",
  
  };